<template>
  <div class="footer-wrapper">
    <!-- SVG Fairground -->
    <!-- Kamu bisa tweak scale, width, height sesuai kebutuhan -->
    <div class="svg-container" v-html="svgContent"></div>
  </div>
</template>

<script>
export default {
  name: "FooterFairground",
  data() {
    return {
      svgContent: `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 400"
        width="100%"
        height="auto"
        preserveAspectRatio="xMidYMin meet"
        >
        <defs>
            <linearGradient id="groundGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F5B367" />
            <stop offset="100%" stop-color="#E68A34" />
            </linearGradient>

            <linearGradient id="groundFarGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F8C27E" />
            <stop offset="100%" stop-color="#F0A557" />
            </linearGradient>

            <linearGradient id="tentMain" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F7C788" />
            <stop offset="100%" stop-color="#E98F3A" />
            </linearGradient>

            <linearGradient id="carouselRoof" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F9C889" />
            <stop offset="100%" stop-color="#E78C38" />
            </linearGradient>

            <linearGradient id="carouselBase" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F4AD5E" />
            <stop offset="100%" stop-color="#DD8233" />
            </linearGradient>

            <linearGradient id="ferrisLegs" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F0AE61" />
            <stop offset="100%" stop-color="#DE8640" />
            </linearGradient>

            <linearGradient id="ferrisCircle" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#F8C27E" />
            <stop offset="100%" stop-color="#F0A557" />
            </linearGradient>
        </defs>

        // dimatikan dlu
        <path
            d="M0 230 Q 250 210 450 220 T 850 215 T 1200 225 L 1200 400 L 0 400 Z"
            fill="url(#groundFarGradient)"
            opacity="0"
        />

        <path
            d="M0 265 Q 240 245 470 255 T 880 250 T 1200 260 L 1200 400 L 0 400 Z"
            fill="url(#groundGradient)"
            opacity="0.58"
        />

        <g transform="translate(120,190) scale(1.05)">

            <rect x="-60" y="90" width="180" height="30" fill="#DE8440" opacity="0.95" />

            <polygon points="30,-10 150,90 -90,90" fill="url(#tentMain)" />

            <polygon points="30,-10 90,90 -30,90" fill="#E99A4B" opacity="0.35" />
            <polygon points="30,-10 150,90 90,90" fill="#E99A4B" opacity="0.18" />

            <rect x="28" y="-55" width="4" height="48" fill="#DE8440" />

            <path d="M32,-50 L78,-40 L32,-32 Z" fill="#E78C38" />
        </g>

        <g transform="translate(1040,205) scale(0.9)">
            <rect x="-50" y="90" width="160" height="25" fill="#DE8440" opacity="0.95" />
            <polygon points="30,-5 140,90 -80,90" fill="url(#tentMain)" />
            <polygon points="30,-5 90,90 -30,90" fill="#E99A4B" opacity="0.35" />
            <polygon points="30,-5 140,90 90,90" fill="#E99A4B" opacity="0.18" />
            <rect x="28" y="-50" width="4" height="47" fill="#DE8440" />
            <path d="M32,-46 L72,-38 L32,-30 Z" fill="#E78C38" />
        </g>

        <g transform="translate(800,110) scale(1.05)">

            <polygon points="40,260 55,100 85,90 70,260" fill="#F0AE61cc" />
            <polygon points="95,260 75,110 105,90 125,260" fill="#F0AE61cc" />

            <ellipse cx="80" cy="270" rx="95" ry="15" fill="#D97C31" opacity="0.3" />

            <circle cx="80" cy="95" r="90" fill="none" stroke="url(#ferrisCircle)" stroke-width="10" />

            <line x1="80" y1="95" x2="80" y2="10" stroke="#F0AE61" stroke-width="10" />
            <line x1="80" y1="95" x2="80" y2="180" stroke="#F0AE61" stroke-width="8" />
            <line x1="80" y1="95" x2="-2" y2="95" stroke="#F0AE61" stroke-width="8" />
            <line x1="80" y1="95" x2="162" y2="95" stroke="#F0AE61" stroke-width="8" />
            <line x1="80" y1="95" x2="25" y2="40" stroke="#F0AE61" stroke-width="8" />
            <line x1="80" y1="95" x2="135" y2="40" stroke="#F0AE61" stroke-width="8" />
            <line x1="80" y1="95" x2="25" y2="150" stroke="#F0AE61" stroke-width="8" />
            <line x1="80" y1="95" x2="135" y2="150" stroke="#F0AE61" stroke-width="8" />

            <circle cx="80" cy="100" r="20" fill="#E78C38" />

            <circle cx="80" cy="10"  r="12" fill="#F7C788" />
            <circle cx="80" cy="180" r="12" fill="#F7C788" />
            <circle cx="-2" cy="95" r="12" fill="#F7C788" />
            <circle cx="162" cy="95" r="12" fill="#F7C788" />
            <circle cx="25" cy="40" r="12" fill="#F7C788" />
            <circle cx="135" cy="40" r="12" fill="#F7C788" />
            <circle cx="25" cy="150" r="12" fill="#F7C788" />
            <circle cx="135" cy="150" r="12" fill="#F7C788" />
        </g>

        <g transform="translate(420,155)">

            <ellipse cx="180" cy="205" rx="150" ry="26" fill="#D97C31" opacity="0.35" />

            <ellipse cx="180" cy="193" rx="140" ry="24" fill="url(#carouselBase)" />

            <rect x="170" y="75" width="20" height="115" fill="#E78C38" />


            <polygon points="40,75 180,-5 320,75" fill="url(#carouselRoof)" />

            <polygon points="180,-5 130,75 230,75" fill="#E78F3A" opacity="0.45" />
            <polygon points="180,-5 90,75 130,75" fill="#E78F3A" opacity="0.25" />
            <polygon points="180,-5 230,75 270,75" fill="#E78F3A" opacity="0.25" />

            <path
            d="M40,75
                Q70,105 100,75
                Q130,105 160,75
                Q190,105 220,75
                Q250,105 280,75
                Q300,95 320,75
                L320,90 L40,90 Z"
            fill="#DE8440"
            />

            <rect x="178" y="-45" width="4" height="43" fill="#DE8440" />

            <path d="M182,-42 L220,-34 L182,-26 Z" fill="#E8913F" />

            <rect x="118" y="60" width="4" height="125" fill="#E69947" />
            <rect x="242" y="65" width="4" height="130" fill="#E69947" />


            <g transform="translate(100,120)">
            <path
                d="M0,24
                C5,6 16,-2 30,-2
                C42,-2 52,5 56,14
                C59,21 58,27 54,30
                L50,32 L50,44
                L34,44 L28,36 L18,44
                L5,44 L0,36 Z"
                fill="#E78F3A"
            />

            <circle cx="38" cy="2" r="5" fill="#D56F25" />

            <rect x="12" y="44" width="4" height="10" fill="#D56F25" />
            <rect x="30" y="44" width="4" height="10" fill="#D56F25" />
            </g>

            <g transform="translate(220,130)">
            <path
                d="M60,24
                C55,6 44,-2 30,-2
                C18,-2 8,5 4,14
                C1,21 2,27 6,30
                L10,32 L10,44
                L26,44 L32,36 L42,44
                L55,44 L60,36 Z"
                fill="#E78F3A"
            />
            <circle cx="22" cy="2" r="5" fill="#D56F25" />
            <rect x="26" y="44" width="4" height="10" fill="#D56F25" />
            <rect x="44" y="44" width="4" height="10" fill="#D56F25" />
            </g>
        </g>

        // dimatikan dlu bagian bwh ini
        <g opacity="0">
            <polygon points="60,240 110,190 160,240" fill="#F0AE61" />
            <polygon points="260,245 300,205 340,245" fill="#F0AE61" />
            <polygon points="1000,245 1040,205 1080,245" fill="#F0AE61" />
        </g>
    </svg>
      `
    }
  }
}
</script>

<style scoped>
.footer-wrapper {
  margin-top:-70px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.svg-container {
  width: 100%;
  max-width: 100vw;
  pointer-events: none;
  user-select: none;
}
</style>
